<script setup lang="ts">
  import { type ModelRef, onMounted, type Ref, ref, watch } from 'vue'
  import CreateOrganizationModal from '@/components/organization/CreateOrganizationModal.vue'
  import type { Organization } from '@/types/organization'
  import { useOrganizationStore } from '@/store/organization.store.ts'
  import type { CreateOrganization } from '@/model/create-organization.model.ts'
  import { DropDown } from '@logistiek-zonder-papier/lzp-library'

  const organizationStore = useOrganizationStore()
  const selectedOrganization: ModelRef<Organization | null> = defineModel<Organization | null>({
    default: null,
  })
  const show: Ref<boolean> = ref<boolean>(false)

  const newClients = ref<Organization[]>()

  onMounted(
    async () => (newClients.value = (await organizationStore.fetchNewClients()) ?? undefined)
  )

  watch(
    () => selectedOrganization.value,
    () => {
      window.dispatchEvent(
        new CustomEvent('select-organization', { detail: selectedOrganization.value })
      )
    }
  )

  defineExpose({ selectedOrganisation: selectedOrganization })

  function selectCreatedOrganization(organizationData: CreateOrganization) {
    selectedOrganization.value =
      newClients.value?.find(
        organization => organization.organisatieNummer === organizationData.organizationNumber
      ) ?? null
  }
</script>

<template>
  <drop-down
    v-model="selectedOrganization"
    :data="newClients ?? []"
    :allow-new="true"
    :enable-search="true"
    label="Organisatie"
    @add="show = true"
  >
    <template #empty>Selecteer adres gegevens</template>
    <template #item="{ item }">
      <span class="selection-option flex-container">
        <span class="item-name">
          {{ item.organisatieNaam }}
        </span>
        <span class="item-name">
          {{ item.organisatieNummer }}
        </span>
        <span class="item-name">
          {{ item.straatnaam }} {{ item.huisNummer }} {{ item.toevoeging }}
          {{ item.postcode }}
        </span>
        <span class="item-name">
          {{ item.land }}
        </span></span
      >
    </template>
  </drop-down>
  <create-organization-modal
    v-model:show="show"
    :owner="true"
    @created="selectCreatedOrganization"
  />
</template>

<style scoped>
  .item-name {
    flex: 1 0 0;
    text-align: left;
  }

  .flex-container {
    display: flex;
    justify-content: space-between;
  }
</style>
